export { default } from './BillingAddBankAccountForm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddBankAccountForm/index.js